import { FC } from 'react';

import clickmeVideoPortfolioDeleteConfirmButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/clickme_video_portfolio_delete_confirm_button_click';
import clickmeVideoPortfolioDeleteKeepButtonClick from '@hh.ru/analytics-js-events/build/clickme/employer/campaign_menu/cpc_flexible/clickme_video_portfolio_delete_keep_button_click';
import { Alert, Button, ButtonStack } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { fetchDeleteVideoFromGallery } from 'components/common/BannerVideo/VideoGallery/RemoveAlert/fetchDeleteVideoFromGallery';

import { useDispatch } from 'store/utils';

const TrlKeys = {
    title: 'AdCreate.AdForm.BannerVideo.VideoGallery.RemoveAlert.title',
    confirm: 'AdCreate.AdForm.BannerVideo.VideoGallery.RemoveAlert.confirm',
    cancel: 'AdCreate.AdForm.BannerVideo.VideoGallery.RemoveAlert.cancel',
};

interface RemoveAlertProps {
    visible: boolean;
    videoUploadId: string;
    onClose: () => void;
}

export const RemoveAlert: FC<RemoveAlertProps> = ({ visible, videoUploadId, onClose }) => {
    const trls = useTrls();
    const dispatch = useDispatch();

    const handleRemove = () => {
        clickmeVideoPortfolioDeleteConfirmButtonClick();
        dispatch(fetchDeleteVideoFromGallery(videoUploadId));
        onClose();
    };

    const handleKeep = () => {
        clickmeVideoPortfolioDeleteKeepButtonClick();
        onClose();
    };

    return (
        <Alert
            visible={visible}
            title={trls(TrlKeys.title)}
            onClose={onClose}
            buttons={
                <ButtonStack stretched layout="horizontal">
                    <Button
                        mode="secondary"
                        style="neutral"
                        onClick={handleKeep}
                        stretched
                        data-qa="remove-video-alert-cancel"
                    >
                        {trls(TrlKeys.cancel)}
                    </Button>
                    <Button
                        mode="primary"
                        style="negative"
                        onClick={handleRemove}
                        stretched
                        data-qa="remove-video-alert-confirm"
                    >
                        {trls(TrlKeys.confirm)}
                    </Button>
                </ButtonStack>
            }
        />
    );
};
